import React from 'react'

import PersonCoverageModal from 'components/PersonCoverageModal'

const ACCIDENT_COVERAGE_DESCRIPTION =
  'We’ll calculate your accident plan pricing based on who you want to cover. Use the checkboxes and click “Save” to make any changes.'

const AccidentCoverageModal = (props) => (
  <PersonCoverageModal description={ACCIDENT_COVERAGE_DESCRIPTION} {...props} />
)

AccidentCoverageModal.displayName = 'AccidentCoverageModal'

export default AccidentCoverageModal
